import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Main from './main';
import Edit from './edit';
import Single from './single';

const WebQrsRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<Main />} />
      <Route path='new' element={<Edit />} />
      <Route path=':id/edit' element={<Edit />} />
      <Route path=':id' element={<Single />} />
      <Route path='*' element={<Navigate to='/' replace />} />
    </Routes>
  );
};

export default WebQrsRoutes;
